export type TreeGetIdArgs = {
  parentIndex?: number;
  ownIndex: number;
  data: {
    id: string;
  };
};

export enum TreeActionType {
  delete = "delete",
  move = "move",
  rename = "rename",
  create = "create",
}

export const TreeSelectionType = {
  independent: 'independent',
  parentChild: 'parentChild',
};